import React from "react";
import { Grid, GridColumn, Separator, TextAlignCenterDiv, Link } from "@atlassiansox/microscopekit";
import DynamicTable from "@atlaskit/dynamic-table";
import ScheduledWargameTemplatesQuery from "../../graphql/scheduled-wargame-templates.query.graphql";
import { parseDateTime, parseDateTimeIso } from "../../utils/Utils";
import SectionMessage from "@atlaskit/section-message";
import { ScheduleStatus, ScheduleType } from "../../../__generated__/graphql-global-types";
import { Filter } from "./Filter";
import { WargameScheduleTableActions } from "../WargameScheduleTableActions";
import { usePollingQuery } from "../../hooks";
var ScheduledWargameTemplatesView = function (props) {
    var _a;
    var _b = usePollingQuery(ScheduledWargameTemplatesQuery, { variables: { id: props.serviceId } }, props.isVisible), loading = _b.loading, data = _b.data;
    var wargameSchedules = ((_a = data === null || data === void 0 ? void 0 : data.schedulesByService) !== null && _a !== void 0 ? _a : []).filter(function (s) {
        return [ScheduleStatus.scheduled, ScheduleStatus.paused].includes(s.status);
    });
    var wargameScheduleMapping = new Map();
    wargameSchedules.forEach(function (schedule) {
        var _a, _b;
        var wargameTemplate = (_a = props.warGameTemplateForService) === null || _a === void 0 ? void 0 : _a.find(function (element) {
            var _a;
            if (((_a = element.id) === null || _a === void 0 ? void 0 : _a.toString()) === schedule.wargameTemplateId) {
                return element;
            }
        });
        if (!wargameScheduleMapping.has(schedule.wargameTemplateId)) {
            wargameScheduleMapping.set(schedule.wargameTemplateId, new Array());
        }
        schedule.wargameTemplateName = wargameTemplate === null || wargameTemplate === void 0 ? void 0 : wargameTemplate.name;
        var concatSchedules = (_b = wargameScheduleMapping.get(schedule.wargameTemplateId)) === null || _b === void 0 ? void 0 : _b.concat(schedule);
        wargameScheduleMapping.set(schedule.wargameTemplateId, concatSchedules ? concatSchedules : new Array());
    });
    return (React.createElement("div", null,
        React.createElement(Separator, null),
        React.createElement("h3", null, "Scheduled Wargame Plans"),
        React.createElement(Separator, null),
        React.createElement(SectionMessage, { appearance: "info" }, "Options to pause, resume and disable schedule can be accessed by clicking on Template ID"),
        React.createElement(Separator, null),
        React.createElement(Grid, null,
            React.createElement(GridColumn, { medium: 12 },
                React.createElement(Filter, { entities: wargameSchedules, fields: {
                        wargameTemplateId: "Template Id",
                        wargameTemplateName: "Template Name",
                        status: "Status"
                    }, includeGap: true, render: function (filteredWargameSchedules) { return (React.createElement(DynamicTable, { isFixedSize: true, emptyView: React.createElement(TextAlignCenterDiv, null, "No Wargame Plans scheduled"), isLoading: loading, rowsPerPage: 10, defaultSortKey: "Template Name", head: {
                            cells: [
                                {
                                    key: "ID",
                                    content: "ID",
                                    isSortable: true,
                                    width: 5
                                },
                                {
                                    key: "Template Name",
                                    content: "Template Name",
                                    isSortable: true,
                                    width: 20
                                },
                                {
                                    key: "Cron/Schedule Time",
                                    content: "Cron/Schedule Time",
                                    isSortable: true,
                                    width: 20
                                },
                                {
                                    key: "Status",
                                    content: "Status",
                                    isSortable: true,
                                    width: 10
                                },
                                {
                                    key: "CreatedAt",
                                    content: "Created At",
                                    isSortable: true,
                                    width: 20
                                },
                                {
                                    key: "Actions",
                                    content: "Actions",
                                    width: 25
                                }
                            ]
                        }, rows: filteredWargameSchedules.map(function (wargameSchedule) {
                            var _a;
                            var createdAt = parseDateTime(wargameSchedule.createdAt ? wargameSchedule.createdAt : "");
                            var scheduleTime = wargameSchedule.scheduleType === ScheduleType.recurring
                                ? wargameSchedule.cronExpression
                                : wargameSchedule.scheduleType === ScheduleType.once
                                    ? parseDateTimeIso((_a = wargameSchedule.scheduleTime) !== null && _a !== void 0 ? _a : "")
                                    : "NA";
                            return {
                                cells: [
                                    {
                                        key: "id-" + wargameSchedule.id,
                                        content: wargameSchedule.id
                                    },
                                    {
                                        key: "templateName-" + wargameSchedule.wargameTemplateName,
                                        content: (React.createElement(Link, { to: "/services/" + encodeURIComponent(props.serviceId) + "/resilience/ondemand/template-details?id=" + wargameSchedule.wargameTemplateId }, wargameSchedule.wargameTemplateName))
                                    },
                                    {
                                        key: "cron-" + scheduleTime,
                                        content: scheduleTime
                                    },
                                    {
                                        key: "status-" + wargameSchedule.status,
                                        content: wargameSchedule.status
                                    },
                                    {
                                        key: "created-at-" + createdAt,
                                        content: createdAt
                                    },
                                    {
                                        key: "actions-" + wargameSchedule.id,
                                        content: (React.createElement(WargameScheduleTableActions, { wargameSchedule: wargameSchedule }))
                                    }
                                ]
                            };
                        }) })); } })))));
};
export var ScheduledWargameTemplates = ScheduledWargameTemplatesView;
